export default class Modal {
    constructor() {
        if (!$('.modaltrigger').length) {
            return false;
        }
        this.items = [];
        this.current = null;
        this.init();
    }

    init() {
        const context = this;
        $('.modaltrigger').each(function () {
            const el = document.getElementById(this.dataset.target);
            if (el) {
                let item = new ModalItem(el, $(this));
                context.items.push(item);
                if (item.open) {
                    context.current = item;
                }
            }
        });
    }
}

export class ModalItem {
    constructor(el, trigger) {
        this.trigger = trigger;
        this.el = $(el);

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onWindowClick = this.onWindowClick.bind(this);
        this.open = false;
        this.init();
    }

    init() {
        if (this.trigger)
            this.trigger.on('click', this.onOpenModal);
        let close = $('.modal-header .close, .modal a[data-bs-dismiss=modal]');
        close.on('click', this.onCloseModal);
        $(window).on('click', this.onWindowClick);
    }
  
  onOpenModal() {   
    this.open = true;
    this.el.show();

    
    $("form", this.el).on("submit", function () {  
      $('input[type="submit"]', this).attr('disabled', 'disabled');
    });

    var productid = this.el.attr("data-product-id");
    if (productid != null) {
      var el_quantity = $("input[data-product-id-quantity='" + productid + "']");
      if (el_quantity != null) {
        $("input[name='quantity']", this.el)[0].value = (el_quantity.val());
      }
    }
        document.addEventListener('keyup', ev => {
            ev.key === 'Escape' ? this.onCloseModal() : null
        })
        $('body').addClass('no-scroll');
        return false;
    }

    onCloseModal() {
        this.open = false;
        this.el.hide();
        document.removeEventListener('keyup', () => null)
        $('body').removeClass('no-scroll');
        return false;
    }

    onWindowClick() {
        if (this.open) {
            // this.onCloseModal();
        }
    }
}